var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createRef, useEffect } from 'react';
import StepInput from './StepInput';
export var addLeadingZero = function (digit) { return digit.toString().padStart(2, '0'); };
var NumberStepInput = function (_a) {
    var _b = _a.step, step = _b === void 0 ? 1 : _b, _c = _a.min, min = _c === void 0 ? 0 : _c, _d = _a.max, max = _d === void 0 ? 59 : _d, value = _a.value, onStepChange = _a.onStepChange, onBlur = _a.onBlur, props = __rest(_a, ["step", "min", "max", "value", "onStepChange", "onBlur"]);
    var ref = createRef();
    useEffect(function () {
        var _a;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('wheel', function (event) {
            event.preventDefault();
        }, {
            passive: false,
        });
        return function () {
            var _a;
            return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('wheel', function (event) {
                event.preventDefault();
            });
        };
    }, []);
    var isNotAllowedValue = function (valueToCheck) {
        // @ts-expect-error
        // eslint-disable-next-line no-restricted-globals
        return isNaN(valueToCheck) ||
            (typeof valueToCheck === 'string' && valueToCheck.trim() === '') ||
            valueToCheck < min ||
            valueToCheck > max;
    };
    var handleStepUp = function () {
        var numberValue = Number(value);
        var addition = numberValue - (numberValue % step) + step;
        var newValue = isNotAllowedValue(addition) ? min : addition;
        onStepChange(addLeadingZero(newValue));
    };
    var handleStepDown = function () {
        var numberValue = Number(value);
        var subtraction = numberValue - (numberValue % step === 0 ? step : numberValue % step);
        var newValue = isNotAllowedValue(subtraction)
            ? max - (max % step === 0 ? 0 : max % step)
            : subtraction;
        onStepChange(addLeadingZero(newValue));
    };
    var handleBlur = function (event) {
        if (isNotAllowedValue(event.target.value)) {
            onBlur(addLeadingZero(min));
        }
        else if (event.target.value.length < 2) {
            onBlur(addLeadingZero(event.target.value));
        }
        else {
            onBlur(event.target.value);
        }
    };
    var handleKeyPress = function (event) {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    };
    var handleKeyDown = function (event) {
        var interactionKeys = ['ArrowUp', 'ArrowDown'];
        if (interactionKeys.indexOf(event.key) > -1) {
            event.preventDefault();
            event.stopPropagation();
            switch (event.key) {
                case 'ArrowUp':
                    handleStepUp();
                    break;
                case 'ArrowDown':
                    handleStepDown();
                    break;
                default:
            }
        }
    };
    var handleWheel = function (event) {
        if (event.deltaY < 0) {
            handleStepUp();
        }
        else if (event.deltaY > 0) {
            handleStepDown();
        }
    };
    return (React.createElement(StepInput, __assign({}, { value: value, ref: ref }, { onStepUp: handleStepUp, onStepDown: handleStepDown, onBlur: handleBlur, onKeyPress: handleKeyPress, onKeyDown: handleKeyDown, onWheel: handleWheel }, props)));
};
export default NumberStepInput;
